import type { HowRelayWorksStage } from "./types";

export const writeTheTestsStage: HowRelayWorksStage = {
  slug: "write-the-tests",
  number: 4,
  name: "Write the tests",
  who: "mixed",
  whoLabel: "AI drafts · you publish",
  oneLiner:
    "Plain-language test steps a person can follow. AI drafts them; you publish them.",
  whatItIs:
    "Tests are step-by-step instructions a person can follow without reading code. Each has realistic test data and a clear expected result. They're grouped into test plans for each feature, and each case checks one of the feature's key outcomes. AI partners write drafts, but only a person can approve a case so that it can be run.",
  youDo: [
    "Open Test-A-Feature, choose the project, and open the feature.",
    "Read each test your AI partner drafted on the feature page, then approve the ones that are right. Any member can approve. Edit or retire the rest.",
  ],
  aiDoes: [
    "Drafts cases from the feature's key outcomes and specs, as numbered steps with an expected result each and realistic data.",
    "Edits a single step when you ask.",
    "Can't approve its own cases.",
  ],
  ifWrong:
    "If your feature isn't listed, add it with its key outcomes to the project in Create-A-Project and publish the project.",
  goThere: "Open Test-A-Feature →",
};
